import React from 'react';
import styled from 'styled-components';
import TextInput from 'sub_components/Common/BloxTextInput';
import { INPUT_TYPES } from 'utils/CommonConstants';

const FeedbackStyle = styled.div`
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const DescriptionScreen = ({
	breakpoint,
	attachment,
	attachmentError,
	attachmentLoading,
	setDescription,
	description,
}) => {
	return (
		<FeedbackStyle
			className='feedback-modal-description-screen'
			id='feedback-modal-description-screen'
		>
			<div className='description-body'>
				<TextInput
					placeholder='Please be as descriptive as possible.'
					type={INPUT_TYPES.TEXTAREA}
					label=''
					name='description'
					value={description}
					onChange={event => setDescription(event.target.value)}
					active={true}
					setDefaultValueAsPlaceholder
					breakpoint={breakpoint}
					cypressId='feedback-description'
				/>
			</div>

			{attachment && !attachmentError && (
				<div className='attachment-wrapper heading71'>{`Attached: ${attachment.filename}`}</div>
			)}
			{!attachment && attachmentLoading && (
				<div className='attachment-wrapper heading71'>{`Uploading your screenshot...`}</div>
			)}
		</FeedbackStyle>
	);
};
